<template>
  <transition name="fade-modal">
    <div

      class="select-store-modal"
      @keydown.esc="close"
    >
      <div class="select-store-modal__header">
        <div class="select-store-modal__circle">
          <svgicon
            name="Illustrative/Location"
            role="presentation"
            :original="true"
          />
        </div>
        <button
          :aria-label="'Stäng fönstret'"
          class="button button--transparent select-store-modal__close"
          @click="close"
        >
          <svgicon
            name="Controls/Close"
            :original="false"
          />
        </button>
      </div>
      <div>
        <search-wrapper
          @search="getStores"
        />
        <div
          v-if="loading"
          class="store-picker__loader"
        >
          <ica-spinner />
        </div>

        <div
          v-if="noResults"
          class="no-stores-result"
        >
          <p>
            Tyvärr kunde vi inte hitta någon butik som levererar matkassen och matchar din sökning.
          </p>
        </div>

        <div
          v-if="renderStores.length"
          class="delivery-methods"
        >
          <p class="delivery-methods--heading">
            Välj leveranssätt
          </p>
          <div class="row-1_md-2">
            <div class="col">
              <button
                class="button button--48 button--secondary button--text-icon"
                :class="{'button--active': deliveryMethod === 0}"
                :disabled="pickup.length == 0"
                @click="selectDeliveryMethod(0)"
              >
                <svgicon name="Delivery/CollectinStore" /> Hämta i butik ({{ pickup.length }})
              </button>
            </div>
            <div class="col">
              <button
                class="button button--48 button--secondary button--text-icon"
                :class="{'button--active': deliveryMethod === 1}"
                :disabled="homeDelivery.length == 0"
                @click="selectDeliveryMethod(1)"
              >
                <svgicon name="Delivery/HomeDelivery" /> Hemleverans ({{ homeDelivery.length }})
              </button>
            </div>
          </div>
        </div>

        <ul
          v-if="renderStores.length"
          class="select-store-modal__result-list"
        >
          <li
            v-for="store in renderStores"
            :key="store.id"
            class="select-store-modal__result"
          >
            <svgicon
              :name="`Logos/${translateStoreType(store.storeProfile)}`"
              role="presentation"
              class="select-store-modal__result--store-type"
              :original="true"
            />
            {{ store.name }}
            <button
              class="button--32 button--secondary"
              @click="setSelectedStore(store)"
            >
              Välj
            </button>
          </li>
        </ul>
        <div
          v-if="showLimit < deliveryMethodStores.length"
          class="row row-spaceAround"
        >
          <div class="col center--text">
            <button
              class="button--32 button--transparent button--text-icon"
              @click="extendLimit"
            >
              Visa fler
              <div class="circle-icon circle-icon--ica-red">
                <svgicon name="Controls/Plus" />
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import "#/Illustrative/Location"
import "#/Logos/ICA"
import "#/Logos/ICA-Nara"
import "#/Logos/ICA-Supermarket"
import "#/Logos/ICA-Kvantum"
import "#/Logos/ICA-Maxi-Stormarknad"
import "#/Controls/Plus"
import "#/Delivery/CollectinStore"
import "#/Delivery/HomeDelivery"
import "#/Controls/Close"
import { mapMutations } from 'vuex'
import axios from 'axios'
import ClickOutside from '../../../plugins/clickOutsideDirective'
import { IcaSpinner } from '~/@ica/ica-molecules-vue/src/components'
import searchWrapper from './searchWrapper'

  export default {
    name: 'SelectStoreModal',
    components: {
      'ica-spinner': IcaSpinner,
      'search-wrapper': searchWrapper
    },
    directives: {
      ClickOutside
    },
    model: {
      prop: 'showModal',
      event: "openstate"
    },
    props: {
      pickup: {
        type: Array,
        default: () => []
      },
      homeDelivery: {
        type: Array,
        default: () => []
      },
      postalAdress: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        noResults: false,
        loading: false,
        showLimit: 3,
        deliveryMethodStores: [],
        deliveryMethod: 0
      }
    },
    computed: {
      hasStores () {
        return this.pickup.length > 0 || this.homeDelivery.length > 0
      },
      renderStores () {
        let deliveryMethod = this.deliveryMethod
        let filteredStores = deliveryMethod == 0 ? this.pickup : this.homeDelivery
        this.setFilteredStore(filteredStores)
        if (this.showLimit != 0 && filteredStores.length > this.showLimit) {
          return filteredStores.slice(0, this.showLimit)
        } else {
          return filteredStores
        }
      },
    },
    methods: {
      ...mapMutations([
        'CLEAR_STORE',
        'CLEAR_DELIVERY_METHOD',
        'SET_STORE',
        'SET_DELIVERY_METHOD',
        'SET_STORE_SEARCH_QUERY'
      ]),
      clearSelectedStore () {
        // This is stupid. Must be rebuilt. Fix me.
        // eslint-disable-next-line vue/no-mutating-props
        this.homeDelivery = []
        // eslint-disable-next-line vue/no-mutating-props
        this.pickup = []
        this.CLEAR_STORE()
        this.CLEAR_DELIVERY_METHOD()
      },
      extendLimit (e) {
        this.showLimit += 3
        e.stopImmediatePropagation()
      },
      translateStoreType (storeType) {
        let val = ''
        switch(storeType) {
          case 0: val = 'ICA'
          break
          case 1: val = 'ICA-Nara'
          break
          case 2: val = 'ICA-Supermarket'
          break
          case 3: val = 'ICA-Kvantum'
          break
          case 4: val = 'ICA-Maxi-Stormarknad'
          break
        }
        return val
      },
      setSelectedStore (store) {
        this.$store.dispatch('setGrocerybagStore',  {
          grocerybagStore: store , deliveryMethod: this.deliveryMethod
        })
        this.$store.dispatch('setGlobalStore', store)
        this.$emit("openstate", false)
      },
       getStores (query) {
        this.SET_STORE_SEARCH_QUERY(query)
        if(this.hasStores){ this.clearSelectedStore()}
        this.loading = true
        this.noResults = false
        axios
          .get(`${this.$root.envConfig.baseUrl}/api/grocerybag/stores?query=${query}`)
          .then(data => {
            this.loading = false
            if (data.data.homeDelivery.length || data.data.pickup.length) {
              // eslint-disable-next-line vue/no-mutating-props
              this.homeDelivery = data.data.homeDelivery
              // eslint-disable-next-line vue/no-mutating-props
              this.pickup = data.data.pickup
            } else {
              this.noResults = true
            }
          })
          .catch(err => {
            console.log(err)
            this.loading = false
            if(err && err.response && err.response.status === 404) {
              this.noResults = true
            }
          })
      },
      selectDeliveryMethod (deliveryMethod) {
        this.deliveryMethod = deliveryMethod
      },
      setFilteredStore (stores) {
        this.deliveryMethodStores = stores
      },
      close (e) {
        if (e.type !== "keydown" && e.clientX !== 0 && e.clientY !== 0) {
          // as we have a click element (by mouse or touch) no need really to return the focus
          this.returnFocusElement = null
        }
        this.$emit("openstate", false)
      },
      closeHandler () {
        this.returnFocusElement && this.returnFocusElement.focus()
      }
    }
  }
</script>

<style lang="scss">
.select-store-modal {
  position: absolute;
  top: 0;
  left: 0;
  background: $color-white;
  width: 100%;
  border-radius: 2rem;
  box-shadow: $box-shadow-primary;
  padding: 0 2rem 2rem;
  text-align: center;
  z-index: 100;

  &__heading {
    @include font(text, 2, "black");

    text-transform: uppercase;
    margin-bottom: 0.5rem;
    padding: 0 2rem;
  }

  &__close {
    position: absolute;
    top: 1rem;
    right: -0.5rem;
    padding: 0;

    svg {
      height: 2rem;
      width: 2rem;

      path {
        fill: $color-grey-dark;
      }
    }
  }

  &__search {
    border: 1px solid $color-grey-light;
    background: $color-grey-lightest;
    padding: 0.75rem 1rem 0.75rem 1rem;
    border-radius: 0.25rem;
    color: $color-grey-dark;
    width: 100%;
    margin-bottom: 1rem;

    &::placeholder {
      color: $color-grey-dark;

      @include font(text, 3, "normal");
    }
  }

  &__header {
    padding-top: 3.5rem;
    position: relative;
  }

  &__circle {
    padding: 1.25rem;
    max-width: 5.5rem;
    max-height: 5.5rem;
    background: white;
    border-radius: 50%;
    position: absolute;
    top: 0%;
    left: 50%;
    width: 100%;
    transform: translate(-50%, -50%);
    box-shadow: 0 0.25rem 0.5rem 0 rgb(249, 245, 245);

    .svg-icon {
      width: 3rem;
      height: 3rem;
    }
  }

  &__result-list {
    margin-top: 2rem;
    margin-bottom: 1rem;
  }

  &__result {
    @include font(text, 3, "bold");

    color: $color-grey-dark;
    padding: 0.75rem 0;
    border-top: 1px solid $color-grey-special;
    display: flex;
    text-align: left;
    align-items: center;

    &--store-type {
      width: auto;
      height: 2rem;
      max-width: 3rem;
      margin-right: 1.5rem;
      display: none;

      @include media-breakpoint-up(md) {
        display: inline-block;
      }
    }

    button {
      margin-left: auto;
      overflow: visible;
    }

    &:last-child {
      border-bottom: 1px solid $color-grey-special;
    }
  }

  .no-stores-result {
    margin: 0 3em;
  }

  .delivery-methods {
    &--heading {
      @include font(text, 2, "black");

      text-transform: uppercase;
      margin-top: 1.5rem;
      margin-bottom: 1rem;
    }
  }

  .button--text-icon {
    width: 100%;

    @include media-breakpoint-up(md) {
      width: inherit;
    }

    .circle-icon.circle-icon--ica-red {
      align-items: center;
      background-color: $color-red-special;
      border-radius: 24px;
      display: inline-flex;
      flex-shrink: 0;
      height: 24px;
      justify-content: center;
      vertical-align: middle;
      width: 24px;
      margin-left: 0.5rem;

      svg {
        margin: 0;
      }
    }
  }
}
</style>
